import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api, formatApiError } from "../lib/api";
import { useI18n } from "../i18n";
import { toast } from "sonner";
import { Loader2, Trophy } from "lucide-react";

/** Join via /join/:code link. If unauth, redirect to register with next param. */
export default function Join() {
    const { code } = useParams();
    const { user, loading } = useAuth();
    const { t } = useI18n();
    const nav = useNavigate();
    const [working, setWorking] = useState(false);

    useEffect(() => {
        if (loading) return;
        if (!user) {
            const next = encodeURIComponent(`/join/${code}`);
            nav(`/register?next=${next}`);
            return;
        }
        (async () => {
            setWorking(true);
            try {
                const { data } = await api.post("/pools/join", { code });
                toast.success(t("dash.toast.joined", { name: data.name }));
                nav(`/pools/${data.id}`);
            } catch (e) {
                toast.error(formatApiError(e.response?.data?.detail) || e.message);
                nav("/dashboard");
            } finally { setWorking(false); }
        })();
    }, [code, user, loading]); // eslint-disable-line

    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center px-4" data-testid="join-page">
            <Trophy className="h-10 w-10 text-[var(--accent-hex)] mb-3" />
            <h1 className="font-heading text-3xl font-bold uppercase tracking-tight text-[var(--text-primary)]">{t("join.title")}</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-1">{t("join.code")} <span className="font-mono text-[var(--accent-hex)] font-bold">{code}</span></p>
            {(loading || working) && <Loader2 className="h-6 w-6 animate-spin text-[var(--accent-hex)] mt-4" />}
            <Link to="/dashboard" className="mt-6 text-xs uppercase tracking-widest font-bold text-[var(--text-secondary)] hover:text-[var(--text-primary)]">{t("join.back")}</Link>
        </div>
    );
}
